<!-- MAIN CONTAINER -->
<div class="d-flex flex-column vh-100">

    <!-- FIXED SPACE FOR MAIN NAV BAR-->
    <div class="container">
        <div class="row my-3 py-3">
        </div>
    </div>

    <!-- FORM HEADER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-4">
            <div class="row">

                <!-- FORM TITLE -->

                <div class="col-6">
                    <h4 class="card-title lg-3 mb-lg-1 text-body-secondary">
                        <i class="bi bi-file-earmark-text me-2 fs-1 text-primary"></i>Factura
                    </h4>
                </div>

                <div class="col-6 align-items-lg-end">
                    <div class="row">
                        <div class="col ms-2 m-lg-0 d-lg-flex justify-content-lg-end align-items-lg-end">
                            <div *ngIf="opE === '1' && mostrarBtnFactura === false " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="validaFormulario(false, true)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                                    <i class="bi-pencil-square me-2"></i>Editar
                                </button>
                            </div>
                            <div *ngIf="opE === '1' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary f-6" data-bs-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">
                                    <i class="bi bi-chat-left-text me-2"></i>Comentario
                                </button>
                            </div>

                            <div *ngIf="opE === '1' && mostrarBtnVoBo === false && this.factura.FacPro_VoBo !== 'VoBo' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="cambioEstatus()" class="INN-function-button link-opacity-50-hover text-decoration-none link-success fs-6">
                                    <i class="bi bi-person-check-fill me-2 "></i>VoBo
                                </button>
                            </div>

                            <div *ngIf="opE === '1' && mostrarBtnFactura === false" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="eliminar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-danger fs-6">
                                    <i class="bi-trash3 me-2"></i>Eliminar
                                </button>
                            </div>

                            <div *ngIf="opE === '2'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="validaFormulario(true, false)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                                    <i class="bi-save me-2"></i>Guardar
                                </button>
                            </div>

                            <div class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="cancelar()" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                                    <i [ngClass]="[iconoMostrar, 'me-2']"></i> {{nameBoton}}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- FORM CONTENT -->
    <div class="container pe-6">
        <div class="card card-body INN-form justify-content-center mt-2">
            <form class="needs-validation" novalidate>
                <div class="row g-3">

                    <div class="collapse multi-collapse" id="multiCollapseExample1">
                        <!-- TEXT AREA -->
                        <div class="col-md-12">
                            <label for="formControlTextarea1" class="form-label">Comentarios</label>
                            <textarea class="form-control" name="factura.FacPro_Observaciones" id="factura.FacPro_Observaciones" [(ngModel)]="factura.FacPro_Observaciones" rows="2" [disabled]="esAdministrador()"></textarea>
                        </div>

                        <br>

                        <button *ngIf="rol === 'Administrador' && factura.FacPro_VoBo !== 'Aclaracion'" (click)="comentarios()" type="button" class="col-3 btn btn-outline-secondary INN-color-white-hover">
                            <i class="bi bi-chat-left-text me-2"></i>Enviar comentarios
                        </button>
                    </div>

                    <!-- FIELD -->
                    <div class="col-md-12">
                        <p class="small text-primary" *ngIf="validacionRol !== 'Otro rol' && opE === '1'">
                            <i class="bi bi-person-circle me-2"> </i> {{validacionRol}} 
                        </p>
                        
                        <label for="Field" class="form-label">No. Factura</label>
                        <input type="text" class="form-control" name="factura.FacPro_NoFactura" id="factura.FacPro_NoFactura" [(ngModel)]="factura.FacPro_NoFactura" #FacPro_NoFactura="ngModel" [ngClass]="{'is-invalid': FacPro_NoFactura.invalid && (FacPro_NoFactura.dirty || FacPro_NoFactura.touched)}"
                            (ngModelChange)="mostrarMensaje(FacPro_NoFactura, 'factura')" (blur)="mostrarMensaje(FacPro_NoFactura, 'factura')" required [disabled]="validacionCampos === false">
                        <p class="invalid-feedback" *ngIf="showErrorMessageNoFac">
                            {{mensajeValidacionNoFac}}
                        </p>
                    </div>

                    <!-- TEXT AREA -->
                    <div class="col-md-12">
                        <label for="formControlTextarea1" class="form-label">Descripción</label>
                        <textarea class="form-control" name="factura.FacPro_Descripcion" id="factura.FacPro_Descripcion" [(ngModel)]="factura.FacPro_Descripcion" #FacPro_Descripcion="ngModel" [ngClass]="{'is-invalid': FacPro_Descripcion.invalid && (FacPro_Descripcion.dirty || FacPro_Descripcion.touched)}"
                            (ngModelChange)="mostrarMensaje(FacPro_Descripcion, 'descripcion')" (blur)="mostrarMensaje(FacPro_Descripcion, 'descripcion')" required rows="3" [disabled]="validacionCampos === false"></textarea>
                        <p class="invalid-feedback" *ngIf="showErrorMessageDesc">
                            {{mensajeValidacionDesc}}
                        </p>
                    </div>

                    <!-- SPACER -->
                    <div class="col-md-9 m-0 p-0"></div>

                    <!-- factura -->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">Proyecto</label>
                        <select class="form-select" name="factura.FKId_Proyecto" id="factura.FKId_Proyecto" [(ngModel)]="factura.FKId_Proyecto" #FKId_Proyecto="ngModel" [ngClass]="{'is-invalid': FKId_Proyecto.invalid && (FKId_Proyecto.dirty || FKId_Proyecto.touched)}" (ngModelChange)="mostrarMensaje(FKId_Proyecto, 'proyecto')"
                            (blur)="mostrarMensaje(FKId_Proyecto, 'proyecto')" required [disabled]="validacionCampos === false">
                            
                            <option [value]="0" disabled>Seleccione el proyecto...</option>

                            <ng-container *ngFor="let proyecto of proyectos">
                                <option *ngIf="proyecto.Pry_Estatus === 'Activo' && proyecto.Pry_Activo" [value]="proyecto.Id_Proyecto">
                                    {{ proyecto.Pry_Clave }}
                                </option>
                            </ng-container>
                        </select>
                        <p class="invalid-feedback" *ngIf="showErrorMessageProy">
                            {{mensajeValidacionProy}}
                        </p>
                    </div>

                    <!-- SPACER -->
                    <!-- <div class="col-md-3 m-0 p-0"></div> -->

                    <!-- LABEL FIELD RIGHT-->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">Fecha de ingreso</label>
                        <div class="input-group">
                            <input class="form-control" type="date" name="factura.FacPro_FechaIngreso" [(ngModel)]="factura.FacPro_FechaIngreso" #FacPro_FechaIngreso="ngModel" [ngClass]="{'is-invalid': FacPro_FechaIngreso.invalid && (FacPro_FechaIngreso.dirty || FacPro_FechaIngreso.touched)}"
                                (ngModelChange)="mostrarMensaje(FacPro_FechaIngreso, 'ingreso')" (blur)="mostrarMensaje(FacPro_FechaIngreso, 'ingreso')"  [max]="maxFechaHoy" required [disabled]="validacionCampos === false">
                            <p class="invalid-feedback" *ngIf="showErrorMessageIng">
                                {{mensajeValidacionIng}}
                            </p>
                        </div>
                    </div>

                    <!-- LABEL FIELD RIGHT-->
                    <div class="col-md-4">
                        <label for="menuField" class="form-label">Mes de servicio</label>
                        <select class="form-select" name="factura.FacPro_MesServicio" [(ngModel)]="factura.FacPro_MesServicio" #FacPro_MesServicio="ngModel" [ngClass]="{'is-invalid': FacPro_MesServicio.invalid && (FacPro_MesServicio.dirty || FacPro_MesServicio.touched)}" (ngModelChange)="mostrarMensaje(FacPro_MesServicio, 'mes')"
                            (blur)="mostrarMensaje(FacPro_MesServicio, 'mes')" required [disabled]="validacionCampos === false">
                            <option value="">Seleccione el mes de servicio...</option>
                            <option *ngFor="let mes of meses" [value]="mes">{{ mes }}</option>
                        </select>
                        <p class="invalid-feedback" *ngIf="showErrorMessageMes">
                            {{mensajeValidacionMes}}
                        </p>
                    </div>

                    <div class="col-md-4">
                        <label for="Field" class="form-label">Año de servicio</label>
                        <div class="input-group">                            

                            <select class="form-select" name="factura.FacPro_AnoServicio" [(ngModel)]="factura.FacPro_AnoServicio" #FacPro_AnoServicio="ngModel" [ngClass]="{'is-invalid': FacPro_AnoServicio.invalid && (FacPro_AnoServicio.dirty || FacPro_AnoServicio.touched)}" (ngModelChange)="mostrarMensaje(FacPro_AnoServicio, 'anio')"
                                (blur)="mostrarMensaje(FacPro_AnoServicio, 'anio')" required [disabled]="validacionCampos === false">
                                <option value="">Seleccione año de servicio...</option>     
                                <option *ngFor="let anioItem of anios;" [ngValue]="anioItem">
                                    {{ anioItem }}
                                </option>
                            </select>
                            <p class="invalid-feedback" *ngIf="showErrorMessageAnio">
                                {{mensajeValidacionAnio}}
                            </p>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <label for="Field" class="form-label">Fecha de facturación</label>
                        <div class="input-group">
                            <input class="form-control" type="date" name="factura.FacPro_FechaFacturacion" [(ngModel)]="factura.FacPro_FechaFacturacion" #FacPro_FechaFacturacion="ngModel" [ngClass]="{'is-invalid': FacPro_FechaFacturacion.invalid && (FacPro_FechaFacturacion.dirty || FacPro_FechaFacturacion.touched)}"
                                (ngModelChange)="mostrarMensaje(FacPro_FechaFacturacion, 'ingreso')" (blur)="mostrarMensaje(FacPro_FechaFacturacion, 'ingreso')" [max]="maxFechaHoy" required [disabled]=" validacionCampos === false ">
                            <p class="invalid-feedback" *ngIf="showErrorMessageIng">
                                {{mensajeValidacionIng}}
                            </p>
                        </div>
                    </div>

                    <!-- LABEL CHECKBOX FIELD -->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">Importe sin IVA</label>
                        <div class="input-group">
                            <span class="input-group-text">$</span>
                            <input type="text" class="form-control" name="factura.FacPro_Importe" min="0" [(ngModel)]="factura.FacPro_Importe" #FacPro_Importe="ngModel" [ngClass]="{'is-invalid': FacPro_Importe.invalid && (FacPro_Importe.dirty || FacPro_Importe.touched)}" (ngModelChange)="mostrarMensaje(FacPro_Importe, 'importe')"
                                (blur)="mostrarMensaje(FacPro_Importe, 'importe')" (input)="filterInput($event)" required [disabled]="validacionCampos === false">
                            <p class="invalid-feedback" [ngClass]="{'d-block': showErrorMessageImp === true}" *ngIf="showErrorMessageImp">
                                {{mensajeValidacionImp}}
                            </p>
                        </div>
                    </div>

                    <div class="col-12" *ngIf="rol === 'Administrador'">
                        <button *ngIf="factura.FacPro_ValidacionFecha === false || factura.FacPro_ValidacionFecha === null" (click)="validarTiempo(true)" type="button" class="col-12 col-md-4 col-lg-3 btn btn-outline-success INN-color-white-hover my-1 me-2">
                            <i class="bi bi-person-check-fill me-2"></i>A tiempo
                        </button>

                        <button *ngIf="factura.FacPro_ValidacionFecha === true || factura.FacPro_ValidacionFecha === null" (click)="validarTiempo(false)" type="button" class="col-12 col-md-4 col-lg-3 btn btn-outline-danger INN-color-white-hover my-1 me-2">
                            <i class="bi bi-clock-history me-2"></i>Fuera de tiempo
                        </button>
                    </div>

                    <!-- BAR -->
                    <hr class="mt-4 mb-0">

                    <!-- COMPONENT PREVIEW PDF -->
                    <app-viewpdf [pdfUrl]="pdfUrl" [modalVisible]="modalVisible" [namepdf]="namepdf" (modalClosed)="onModalClosed()" *ngIf="modalVisible"></app-viewpdf>

                    <app-loading [loading]="loading" [message]="message" [loadingDocuments]="loadingDocuments" [progressPercentage]="progressPercentage"></app-loading>

                    <div class="container mt-4">
                        <div class="card">
                            <div class="card-body">
                                <!-- Tabla de Documentos Almacernados en S3 -->
                                <div class="row g-3">
                                    <h5 class="card-title" *ngIf="attachments.length > 1">Documentos Adjuntos</h5>

                                    <div class="col-sm-12 col-md-6 col-lg-3" *ngFor="let document of attachments; let i=index">
                                        <div class="input-group mb-3">
                                            <div title="Ver">
                                                <button type="button" class="btn btn-outline-danger INN-color-white-hover btn-pdf" (click)="openModal(document)">
                                                    <i class="bi bi-file-earmark-pdf-fill"></i>
                                                </button>
                                            </div>

                                            <input type="text" class="form-control" placeholder="{{document.FacDoc_Nombre}}" disabled aria-label="Username" aria-describedby="basic-addon1">

                                            <div title="Descargar">
                                                <button class="btn btn-outline-primary INN-color-white-hover rounded-0" type="button" id="basic-addon1" (click)="downloadDocument(document)">
                                                    <i class="bi bi-download  px-1"></i>
                                                </button>
                                            </div>

                                            <div title="Eliminar Documento(Si se elimina no se podra recuperar)" [ngClass]="{'disabled-section': factura.FacPro_VoBo === 'VoBo' && rol !== 'Administrador'}">
                                                <button class="btn btn-outline-danger btn-delete" type="button" id="basic-addon1" (click)="deleteDocumentS3(document)">
                                                    <i class="bi bi-trash px-1"></i>
                                                </button>
                                            </div>

                                        </div>
                                    </div>

                                </div>

                                <h5 class="card-title mt-5 text-center">Agregar Facturas </h5>
                                <p class="text-secondary text-center">(Solo Admite Archivos PDF)</p>

                                <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" [ngClass]="{'disabled-section': factura.FacPro_VoBo === 'VoBo' && rol !== 'Administrador'}">
                                    <ng-template (click)="openFileSelector()" ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                                        <p (click)="openFileSelector()">Arrastra y suelta tus archivos aquí o haz clic para seleccionar archivos.</p>
                                        <input type="file" id="fileInput" style="display: none">
                                    </ng-template>
                                </ngx-file-drop>

                            </div>

                        </div>
                        <!-- SPACER -->
                        <div class="col-md-6 m-0 p-0"></div>
                        <br>
                    </div>

                    <!-- Tabla de Documentos al Agregar -->
                    <div class="row g-3">
                        <h5 class="card-title" *ngIf="newdocuments.length > 1">Documentos nuevos</h5>
                        <div class="col-md-4" *ngFor="let document of newdocuments; let i=index">
                            <div class="input-group mb-3">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="bi bi-file-earmark-pdf-fill text-danger"></i>
                                </span>
                                <input type="text" class="form-control" placeholder="{{document.name}}" disabled aria-label="Username" aria-describedby="basic-addon1">
                                <div title="Eliminar Documento">
                                    <button class="btn btn-outline-danger btn-delete" type="button" id="basic-addon1" (click)="quitDocument(i)">
                                        <i class="bi bi-trash px-1"></i>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- SPACER -->
                    <div class="col-md-6 m-0 p-0"></div>

                </div>
            </form>
        </div>
    </div>

    <!-- FORM FOOTER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-2 mb-4">
            <div class="row">

                <!-- FORM FOOTER CONTENT -->
                <!-- FUNCTIONS BUTTONS -->
                <div class="col ms-2 m-lg-0 d-lg-flex justify-content-lg-end align-items-lg-end">
                    <div *ngIf="opE === '1' && mostrarBtnFactura === false " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(false, true)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i class="bi-pencil-square me-2"></i>Editar
                        </button>
                    </div>
                    <div *ngIf="opE === '1' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary f-6" data-bs-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">
                            <i class="bi bi-chat-left-text me-2"></i>Comentario
                        </button>
                    </div>

                    <div *ngIf="opE === '1' && mostrarBtnVoBo === false && this.factura.FacPro_VoBo !== 'VoBo' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="cambioEstatus()" class="INN-function-button link-opacity-50-hover text-decoration-none link-success fs-6">
                            <i class="bi bi-person-check-fill me-2 "></i>VoBo
                        </button>
                    </div>

                    <div *ngIf="opE === '1' && mostrarBtnFactura === false" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="eliminar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-danger fs-6">
                            <i class="bi-trash3 me-2"></i>Eliminar
                        </button>
                    </div>

                    <div *ngIf="opE === '2'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(true, false)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i class="bi-save me-2"></i>Guardar
                        </button>
                    </div>

                    <div class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="cancelar()" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i [ngClass]="[iconoMostrar, 'me-2']"></i> {{nameBoton}}
                        </button>
                    </div>

                </div>
            </div>
        </div>

        <!-- FORM FOOTER -->
        <div class="container">
            <div class="row mb-4 pb-4"></div>
        </div>

    </div>
    <!-- END MAIN CONTAINER -->
